import { Component, HostListener, OnDestroy, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { share } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { isClassicGapHost } from '../../shared/brand';
import { SetWarrantyFlag } from '../warranty-creator/store/warranty-creator.actions';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit, OnDestroy {
  isWarranty$: Observable<boolean> = of(false);

  classicGap = isClassicGapHost();

  isOpen = false;
  activeFragment = this.activatedRoute.fragment.pipe(share());
  environment = environment;
  private scrollLocked = false;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    @Optional() private store?: Store,
  ) {}

  ngOnInit(): void {
    this.isWarranty$ = of(!this.classicGap);
    if (!this.store) {
      return;
    }
    this.store.dispatch(new SetWarrantyFlag(!this.classicGap));
  }

  ngOnDestroy(): void {
    this.setScrollLock(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen) {
      this.closeMenu();
    }
  }

  toggleMenu(): void {
    this.isOpen = !this.isOpen;
    this.setScrollLock(this.isOpen);
  }

  closeMenu(): void {
    this.isOpen = false;
    this.setScrollLock(false);
  }

  private setScrollLock(locked: boolean): void {
    if (locked === this.scrollLocked) {
      return;
    }
    this.scrollLocked = locked;
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  redirectToWarrantiesApk() {
    window.location.replace(environment.apkUrl);
  }

  openTopBarUrl(url: string): void {
    window.open(url, '_blank');
  }
}
